import { useState,useEffect } from 'react';
import { Search, Filter,ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ExtendTimePopup from '../../RFQs/ExtendTimePopup';
import { Package} from "lucide-react";

const calculateRemainingTime = (time_expired_at) => {
  if (!time_expired_at) return "--";

  const expiry = new Date(time_expired_at).getTime();
  const now = Date.now();
  const diff = expiry - now;

  if (diff <= 0) return "Time Completed";

  const minutes = Math.floor(diff / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  return `${minutes}m ${seconds}s`;
};

export default function RFQManager() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
    const [countdowns, setCountdowns] = useState({});
   
  const [rfqs, setRfqs] = useState([ ]);
  const [showExtendPopup, setShowExtendPopup] = useState(false);
  const [selectedRFQ, setSelectedRFQ] = useState(null);
  const [searchText, setSearchText] = useState("");
const [filteredRFQs, setFilteredRFQs] = useState([]);
const [selectedStatus, setSelectedStatus] = useState([]);
const [showStatusDropdown, setShowStatusDropdown] = useState(false);
const STATUS_OPTIONS = [
  "Waiting For Supplier Responses",
  "Waiting For Best Prices",
  "Final Price Received",
  "Cancelled",
  "Order Placed Sucessfully",
  "Order Confirmed",
];

const RFQ_STATUS_TEXT_COLORS = {
  "Waiting For Supplier Responses": "text-yellow-700 bg-yellow-50",
  "Waiting For Best Prices": "text-blue-600 bg-blue-50",
  "Final Price Received": "text-green-600 bg-green-50",
  "Cancelled": "text-red-600 bg-red-50",
  "Order Placed Sucessfully": "text-green-700 bg-green-50",
  "Order Confirmed": "text-green-700 bg-green-50",
};

const toggleStatus = (status) => {
  setSelectedStatus((prev) =>
    prev.includes(status)
      ? prev.filter((s) => s !== status)
      : [...prev, status]
  );
};

const toggleSelectAll = () => {
  setSelectedStatus((prev) =>
    prev.length === STATUS_OPTIONS.length ? [] : STATUS_OPTIONS
  );
};

const clearAll = () => {
  setSelectedStatus([]);
};

useEffect(() => {
  const handleOutside = (e) => {
    if (!e.target.closest(".status-dropdown")) {
      setShowStatusDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleOutside);

  return () => {
    document.removeEventListener("mousedown", handleOutside);
  };
}, []);


  const handleAction = (rfqId, action) => {
    alert(`Action "${action}" performed on RFQ ${rfqId}`);

    setRfqs(rfqs.map(rfq => {
      if (rfq.id !== rfqId) return rfq;
      if (action === 'Submit Quote') return { ...rfq, status: 'quoted' };
      if (action === 'Approve') return { ...rfq, status: 'approved' };
      if (action === 'Reject') return { ...rfq, status: 'rejected' };
      return rfq;
    }));
  };

  const getStatusIcon = (status) => {
    if (status === 'pending') return <span className="inline-block w-4 h-4 bg-gray-400 rounded-full"></span>;
    if (status === 'quoted') return <span className="inline-block w-4 h-4 bg-blue-400 rounded-full"></span>;
    if (status === 'approved') return <span className="inline-block w-4 h-4 bg-green-400 rounded-full"></span>;
    if (status === 'rejected') return <span className="inline-block w-4 h-4 bg-red-400 rounded-full"></span>;
  };

  const getStatusColor = (status) => {
    if (status === 'pending') return 'bg-gray-200 text-gray-800';
    if (status === 'quoted') return 'bg-blue-200 text-blue-800';
    if (status === 'approved') return 'bg-green-200 text-green-800';
    if (status === 'rejected') return 'bg-red-200 text-red-800';
  };


  // ✅ Fetch RFQs
  const fetchRFQs = async () => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-all-customer-Rfqs`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json", "x-token": token },
        }
      );
      const resData = await response.json();
      const data = resData?.data || [];
      console.log(data);
      setRfqs(data);
      setFilteredRFQs(data);
    } catch (error) {
      console.error("Error fetching RFQs:", error.message);
    } finally {
      setLoading(false);
    }
  };

const refresh = () => {
  fetchRFQs();
};


  useEffect(() => {
    fetchRFQs();
  }, []);

    useEffect(() => {
    const interval = setInterval(() => {
      const updated = {};
  
      rfqs.forEach((rfq) => {
        updated[rfq._id] = calculateRemainingTime(rfq.time_expired_at);
      });
    //console.log(updated)
      setCountdowns(updated);
    }, 1000);
  
    return () => clearInterval(interval);
  }, [rfqs]);



  useEffect(() => {
  let data = [...rfqs];

  // 🔍 SEARCH FILTER
  if (searchText.trim()) {
    const value = searchText.toLowerCase();
    data = data.filter(
      (rfq) =>
        rfq?.rfq_number?.toLowerCase().includes(value) ||
        rfq?.order_number?.toLowerCase().includes(value) ||
        rfq?.status?.toLowerCase().includes(value) ||
        rfq?.customer?.name?.toLowerCase().includes(value)
    );
  }

  // 🟢 STATUS FILTER
if (selectedStatus.length > 0) {
  data = data.filter((rfq) =>
    selectedStatus.includes(rfq?.status)
  );
}

  setFilteredRFQs(data);
}, [searchText, selectedStatus, rfqs]);


const handleExtendTime = (rfq) => {
  setSelectedRFQ(rfq);
  setShowExtendPopup(true);
};


const handleReactivateRFQ = async (rfq) => {
 // setSelectedRFQ(rfq);
  //setShowExtendPopup(true);
  console.log('it is not implemented at ')
};

  return (
    <div className="border rounded-lg shadow-sm ">
      {/* Header */}
    <div className="flex flex-wrap items-center gap-3 mb-4 p-6">
      {/* Search Input with Icon */}
      <div className="relative flex-1 min-w-[240px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />

        <input
       type="text"
      placeholder="Search by Orders or Shipments"
      value={searchText}
     onChange={(e) => setSearchText(e.target.value)}
     className="w-full pl-10 pr-4 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      </div>

      {/* Filter Dropdown with Icon */}
     <div className="relative status-dropdown">
  <Filter className="absolute left-3 top-3 w-4 h-4 text-gray-400 pointer-events-none" />

  <button
    type="button"
    onClick={() => setShowStatusDropdown(!showStatusDropdown)}
    className="pl-10 pr-8 py-2 border rounded-md text-sm bg-white focus:outline-none  min-w-[220px] text-left"
  >
    {selectedStatus.length === 0
      ? "All Status"
      : `${selectedStatus.length} Selected`}
        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />

  </button>

  {showStatusDropdown && (
    <div className="absolute z-20 mt-1 w-full bg-white border rounded-md shadow-lg">
      
      {/* TOP ROW → ALL STATUS + CLEAR */}
      <div className="flex items-center justify-between px-3 py-2 border-b">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={selectedStatus.length === STATUS_OPTIONS.length}
            onChange={toggleSelectAll}
          />
          <span className="text-sm font-medium">All Status</span>
        </label>

        <button
          onClick={clearAll}
          className="text-xs text-red-600 hover:underline"
        >
          Clear
        </button>
      </div>

      {/* STATUS LIST */}
      {STATUS_OPTIONS.map((status) => (
        <label
          key={status}
          className="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 cursor-pointer"
        >
          <input
            type="checkbox"
            checked={selectedStatus.includes(status)}
            onChange={() => toggleStatus(status)}
          />
          <span className="text-sm">{status}</span>
        </label>
      ))}
    </div>
  )}
</div>


    </div>


      {/* Table */}
{!loading && rfqs.length === 0 ? (
  <div className="flex flex-col items-center justify-center py-16 text-gray-500">
    <Package className="w-8 h-8 mb-2 text-gray-400" />
    <p className="text-sm font-medium">No RFQs Found</p>
  </div>
) : (
<div className="relative overflow-x-auto overflow-y-auto max-h-[60vh]">
  <table className="min-w-full divide-y divide-gray-200 table-fixed">
    <thead className="bg-gray-50 sticky top-0 z-10">
      <tr>
        <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
          RFQ Number
        </th>
         <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
          RFQ Created Time
        </th>
         <th className="px-4 py-2 text-center text-sm font-medium text-gray-700 ">
          RFQ Created Date
        </th>
        <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">
          Order No
        </th>
        <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">
          Status
        </th>
        <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">
          Time Left
        </th>
        <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">
          Responses
        </th>
        <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">
          Customer
        </th>
      </tr>
    </thead>

    <tbody className="bg-white divide-y divide-gray-200">
      {loading ? (
        <tr>
          <td colSpan={6} className="text-center py-12">
            <p className="text-sm text-gray-500">Loading...</p>
          </td>
        </tr>
      ) : filteredRFQs.length === 0 ? (
        <tr>
          <td colSpan={6} className="text-center py-12">
            <div className="flex flex-col items-center justify-center">
              <Search className="w-6 h-6 text-gray-400 mb-2" />
              <p className="text-sm text-gray-500 leading-relaxed">
                No Result Found
              </p>
            </div>
          </td>
        </tr>
      ) : (
        filteredRFQs.map(rfq => (
          <tr
            key={rfq?._id}
            className="hover:bg-gray-50 cursor-pointer"
            onClick={() =>
              navigate('/bb/app/rfqfullfillmentflow', {
                state: { rfq_id: rfq?._id }
              })
            }
          >
            <td className="px-4 py-2 text-left text-gray-800 text-sm">
              {rfq?.rfq_number}
            </td>
             <td className="px-4 py-2 text-left text-gray-800 text-sm">
               <span className="font-regular">
      {new Date(rfq.createdAt).toLocaleTimeString([], { 
        hour: "2-digit", 
        minute: "2-digit", 
        hour12: true 
      })}
    </span>
            </td>
             <td className="px-4 py-2 text-center text-gray-800 text-sm">
              {new Date(rfq?.createdAt).toLocaleDateString()}
            </td>

            <td className="px-4 py-2 text-center text-gray-800 text-sm">
              {rfq?.order_number || '--'}
            </td>

            <td className="px-4 py-2 text-center text-xs text-gray-800">
              <span
                className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full  ${RFQ_STATUS_TEXT_COLORS[rfq.status]}`}
              >
                {getStatusIcon(rfq.status)}
                <span className="ml-1">{rfq.status}</span>
              </span>
            </td>

            <td className="px-4 py-2 text-center">
              {rfq.status === "Order Confirmed" && (
                <span className="text-gray-400">--</span>
              )}
              {rfq.status === "Cancelled" && (
                <div className="flex flex-col items-center gap-1">
                  <span className="text-red-500 text-xs font-semibold">--</span>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleReactivateRFQ(rfq);
                    }}
                    className="text-blue-600 text-xs underline"
                  >
                    Reactivate
                  </button>
                </div>
              )}
              {(rfq.status === "Waiting For Supplier Responses" ||
                rfq.status === "Waiting For Payment") && (
                <span className="text-gray-600 text-sm">
                  {countdowns[rfq._id]}
                </span>
              )}
            </td>

            <td className="px-4 py-2 text-center">
              <button className="text-blue-600 font-semibold text-sm hover:underline">
                {rfq.suppliers?.responded || 0} / {rfq.suppliers?.total || 0}
              </button>
            </td>

            <td className="px-4 py-2 text-center">
              <div className="flex flex-col leading-tight">
                <span className="text-sm text-gray-800">
                  {rfq?.customer?.name}
                </span>
                <span className="text-sm text-gray-800">
                  {rfq?.customer?.mobile}
                </span>
              </div>
            </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>

)}


    
    {showExtendPopup && selectedRFQ && (
            <ExtendTimePopup
              rfq={selectedRFQ}
              refresh={refresh}
              onClose={() => setShowExtendPopup(false)}
            />
          )}

    </div>
  );
}
